import { currencyToNumber } from '@iwoca/orion';
import * as yup from 'yup';

import { LOAN_DURATION_OPTIONS_UK } from './LoanDurationUK';
import { LOAN_PURPOSE_OPTIONS_UK } from './LoanPurposeUK';

type TLoanDurationValue = (typeof LOAN_DURATION_OPTIONS_UK)[number]['value'];
type TLoanPurposeValue = (typeof LOAN_PURPOSE_OPTIONS_UK)[number]['value'];

export const schema = yup.object().shape({
  email: yup
    .string()
    .email('Please use a valid email format')
    .matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: 'Please use a valid email format',
      excludeEmptyString: true,
    })
    .required('Email address required'),
  amount: yup
    .string()
    .required('Loan amount required')
    .test('minCurrencyAmount', 'Between £1,000 and £1,000,000', (value) => {
      const numericValue = currencyToNumber(value, {
        currencySymbol: true,
        locale: 'en-GB',
        minorUnits: false,
      });
      if (!numericValue) return false;
      return numericValue >= 1000 && numericValue <= 1000000;
    }),
  loanDuration: yup
    .string<TLoanDurationValue>()
    .required('Loan duration required'),
  loanPurpose: yup
    .string<TLoanPurposeValue>()
    .required('Loan purpose required'),
  marketingOptIn: yup.boolean().optional(),
});
